// Libraries
import React, { useState } from 'react'
import * as yup from 'yup'
import PropTypes from 'prop-types'

// Components
import Text from 'ui/Text'
import Steps from 'ui/Steps'
import Input from 'ui/Form/Input'
import Heading from 'ui/Heading'
import Space from 'ui/Space'
import Button from 'ui/Button'
import Box from 'ui/Box'

// Use
import { useFormHook } from 'use/form'
import useQuery from 'use/query'

// Api
import { checkCode } from 'api/register'

// Validation schema
const validationSchema = yup.object().shape({
  securityCode: yup.string().required('The security code field is required'),
})

function RegisterCheckCode({ onSubmit }) {
  // State
  const [isLoading, setLoading] = useState(false)

  // Use hook
  const { ref } = useQuery()

  // UseFormHook
  const { form, errors, validate, setFieldError, onChange, onBlur } =
    useFormHook({
      schema: validationSchema,
      initialForm: {
        securityCode: '',
      },
    })

  const onSubmitCheckCode = async (e) => {
    e.preventDefault()

    await validate()

    setLoading(true)

    try {
      await checkCode({
        registerCode: ref,
        securityCode: form.securityCode,
      })

      onSubmit()
    } catch ({ response }) {
      return setFieldError(
        'securityCode',
        <div>
          Invalid security code. <br />
          Please check your email invite to get the correct one.
        </div>
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box backgroundColor={'transparent'} style={{ minWidth: '85%' }}>
      <form onSubmit={onSubmitCheckCode}>
        <Heading paddingTop={0} paddingBottom={10}>
          Hi Ka-Globe!
        </Heading>
        <Text size={18} color="#000" paddingBottom={10}>
          Let’s get started by activating your Paytrack account
        </Text>
        <Space className="w-100" direction="vertical">
          <Steps stepsLength={2} current={1} />
          <div style={{ maxWidth: 380 }}>
            <Input
              value={form.securityCode}
              label="Security code"
              name="securityCode"
              placeholder="Security code here"
              errors={errors}
              onChange={onChange}
              onBlur={onBlur}
            />
          </div>
        </Space>
        <Button width="250px" type="submit" loading={isLoading}>
          Next
        </Button>
      </form>
    </Box>
  )
}

RegisterCheckCode.propTypes = {
  onSubmit: PropTypes.func,
}

RegisterCheckCode.defaultProps = {
  onSubmit: () => {},
}

export default RegisterCheckCode
